export const START_LOADER = "START_LOADER";
export const STOP_LOADER = "STOP_LOADER";
export const COMPANIES_REQUEST = "COMPANIES_REQUEST";
export const COMPANIES_REQUEST_SUCCESS = "COMPANIES_REQUEST_SUCCESS";
export const COMPANIES_REQUEST_FAIL = "COMPANIES_REQUEST_FAIL";
export const COMPANIES_SEARCH_REQUEST = "COMPANIES_SEARCH_REQUEST";
export const COMPANIES_SEARCH_REQUEST_SUCCESS =
  "COMPANIES_SEARCH_REQUEST_SUCCESS";
export const COMPANIES_SEARCH_REQUEST_FAIL = "COMPANIES_SEARCH_REQUEST_FAIL";
export const COMPANY_CREATE_REQUEST = "COMPANY_CREATE_REQUEST";
export const COMPANY_CREATE_REQUEST_SUCCESS = "COMPANY_CREATE_REQUEST_SUCCESS";
export const COMPANY_CREATE_REQUEST_FAIL = "COMPANY_CREATE_REQUEST_FAIL";
export const COMPANY_UPDATE_REQUEST = "COMPANY_UPDATE_REQUEST";
export const COMPANY_UPDATE_REQUEST_SUCCESS = "COMPANY_UPDATE_REQUEST_SUCCESS";
export const COMPANY_UPDATE_REQUEST_FAIL = "COMPANY_UPDATE_REQUEST_FAIL";
export const COMPANY_FIND_REQUEST = "COMPANY_FIND_REQUEST";
export const COMPANY_FIND_REQUEST_SUCCESS = "COMPANY_FIND_REQUEST_SUCCESS";
export const COMPANY_FIND_REQUEST_FAIL = "COMPANY_FIND_REQUEST_FAIL";
export const COMPANY_DELETE_REQUEST = "COMPANY_DELETE_REQUEST";
export const COMPANY_DELETE_REQUEST_SUCCESS = "COMPANY_DELETE_REQUEST_SUCCESS";
export const COMPANY_DELETE_REQUEST_FAIL = "COMPANY_DELETE_REQUEST_FAIL";
export const SELECT_COMPANY = "SELECT_COMPANY";
export const EMPLOYEES_REQUEST = "EMPLOYEES_REQUEST";
export const EMPLOYEES_REQUEST_SUCCESS = "EMPLOYEES_REQUEST_SUCCESS";
export const EMPLOYEES_REQUEST_FAIL = "EMPLOYEES_REQUEST_FAIL";
export const EMPLOYEE_CREATE_REQUEST = "EMPLOYEE_CREATE_REQUEST";
export const EMPLOYEE_CREATE_REQUEST_SUCCESS =
  "EMPLOYEE_CREATE_REQUEST_SUCCESS";
export const EMPLOYEE_CREATE_REQUEST_FAIL = "EMPLOYEE_CREATE_REQUEST_FAIL";
export const EMPLOYEE_SEARCH_REQUEST = "EMPLOYEE_SEARCH_REQUEST";
export const EMPLOYEE_SEARCH_REQUEST_SUCCESS =
  "EMPLOYEE_SEARCH_REQUEST_SUCCESS";
export const EMPLOYEE_SEARCH_REQUEST_FAIL = "EMPLOYEE_SEARCH_REQUEST_FAIL";
export const EMPLOYEE_UPDATE_REQUEST = "EMPLOYEE_UPDATE_REQUEST";
export const EMPLOYEE_UPDATE_REQUEST_SUCCESS =
  "EMPLOYEE_UPDATE_REQUEST_SUCCESS";
export const EMPLOYEE_UPDATE_REQUEST_FAIL = "EMPLOYEE_UPDATE_REQUEST_FAIL";
export const EMPLOYEE_FIND_REQUEST = "EMPLOYEE_FIND_REQUEST";
export const EMPLOYEE_FIND_REQUEST_SUCCESS = "EMPLOYEE_FIND_REQUEST_SUCCESS";
export const EMPLOYEE_FIND_REQUEST_FAIL = "EMPLOYEE_FIND_REQUEST_FAIL";
export const EMPLOYEE_DELETE_REQUEST = "EMPLOYEE_DELETE_REQUEST";
export const EMPLOYEE_DELETE_REQUEST_SUCCESS =
  "EMPLOYEE_DELETE_REQUEST_SUCCESS";
export const EMPLOYEE_DELETE_REQUEST_FAIL = "COMPANY_DELETE_REQUEST_FAIL";
export const SELECT_EMPLOYEE = "SELECT_EMPLOYEE";
export const CUSTOMERS_REQUEST = "CUSTOMERS_REQUEST";
export const CUSTOMERS_REQUEST_SUCCESS = "CUSTOMERS_REQUEST_SUCCESS";
export const CUSTOMERS_REQUEST_FAIL = "CUSTOMERS_REQUEST_FAIL";
export const CUSTOMER_CREATE_REQUEST = "CUSTOMER_CREATE_REQUEST";
export const CUSTOMER_CREATE_REQUEST_SUCCESS =
  "CUSTOMER_CREATE_REQUEST_SUCCESS";
export const CUSTOMER_CREATE_REQUEST_FAIL = "CUSTOMER_CREATE_REQUEST_FAIL";
export const CUSTOMER_UPDATE_REQUEST = "CUSTOMER_UPDATE_REQUEST";
export const CUSTOMER_UPDATE_REQUEST_SUCCESS =
  "CUSTOMER_UPDATE_REQUEST_SUCCESS";
export const CUSTOMER_UPDATE_REQUEST_FAIL = "CUSTOMER_UPDATE_REQUEST_FAIL";
export const CUSTOMER_FIND_REQUEST = "CUSTOMER_FIND_REQUEST";
export const CUSTOMER_FIND_REQUEST_SUCCESS = "CUSTOMER_FIND_REQUEST_SUCCESS";
export const CUSTOMER_FIND_REQUEST_FAIL = "CUSTOMER_FIND_REQUEST_FAIL";
export const CUSTOMER_DELETE_REQUEST = "CUSTOMER_DELETE_REQUEST";
export const CUSTOMER_DELETE_REQUEST_SUCCESS =
  "CUSTOMER_DELETE_REQUEST_SUCCESS";
export const CUSTOMER_DELETE_REQUEST_FAIL = "CUSTOMER_DELETE_REQUEST_FAIL";
export const SELECT_CUSTOMER = "SELECT_CUSTOMER";
export const BUDGET_CREATE_REQUEST = "BUDGET_CREATE_REQUEST";
export const BUDGET_CREATE_REQUEST_SUCCESS = "BUDGET_CREATE_REQUEST_SUCCESS";
export const BUDGET_CREATE_REQUEST_FAIL = "BUDGET_CREATE_REQUEST_FAIL";
export const BUDGET_ATTACHMENT_REQUEST = "BUDGET_ATTACHMENT_REQUEST";
export const BUDGET_UPDATE_REQUEST = "BUDGET_UPDATE_REQUEST";
export const BUDGET_UPDATE_REQUEST_SUCCESS = "BUDGET_UPDATE_REQUEST_SUCCESS";
export const BUDGET_UPDATE_REQUEST_FAIL = "BUDGET_UPDATE_REQUEST_FAIL";
export const BUDGET_DELETE_REQUEST = "BUDGET_DELETE_REQUEST";
export const BUDGET_DELETE_REQUEST_SUCCESS = "BUDGET_DELETE_REQUEST_SUCCESS";
export const BUDGET_DELETE_REQUEST_FAIL = "BUDGET_DELETE_REQUEST_FAIL";
export const BUDGET_FIND_REQUEST = "BUDGET_FIND_REQUEST";
export const BUDGET_FIND_REQUEST_SUCCESS = "BUDGET_FIND_REQUEST_SUCCESS";
export const BUDGET_FIND_REQUEST_FAIL = "BUDGET_FIND_REQUEST_FAIL";
export const SELECT_BUDGET = "SELECT_BUDGET";
export const BUDGETS_REQUEST = "BUDGETS_REQUEST";
export const BUDGETS_REQUEST_FAIL = "BUDGETS_REQUEST_FAIL";
export const BUDGETS_REQUEST_SUCCESS = "BUDGETS_REQUEST_SUCCESS";
export const ADDRESS_CUSTOMER_CREATE_REQUEST =
  "ADDRESS_CUSTOMER_CREATE_REQUEST";
export const ADDRESS_CUSTOMER_DELETE_REQUEST =
  "ADDRESS_CUSTOMER_DELETE_REQUEST";
export const ADDRESS_CUSTOMER_UPDATE_REQUEST =
  "ADDRESS_CUSTOMER_UPDATE_REQUEST";
export const ADDRESSES_REQUEST = "ADDRESSES_REQUEST";
export const ADDRESSES_REQUEST_SUCCESS = "ADDRESSES_REQUEST_SUCCESS";
export const ADDRESSES_REQUEST_FAIL = "ADDRESSES_REQUEST_FAIL";
export const ADDRESS_CREATE_REQUEST = "ADDRESS_CREATE_REQUEST";
export const ADDRESS_CREATE_REQUEST_SUCCESS = "ADDRESS_CREATE_REQUEST_SUCCESS";
export const ADDRESS_CREATE_REQUEST_FAIL = "ADDRESS_CREATE_REQUEST_FAIL";
export const ADDRESS_UPDATE_REQUEST = "ADDRESS_UPDATE_REQUEST";
export const ADDRESS_UPDATE_REQUEST_SUCCESS = "ADDRESS_UPDATE_REQUEST_SUCCESS";
export const ADDRESS_UPDATE_REQUEST_FAIL = "ADDRESS_UPDATE_REQUEST_FAIL";
export const ADDRESS_DELETE_REQUEST = "ADDRESS_DELETE_REQUEST";
export const ADDRESS_DELETE_REQUEST_SUCCESS = "ADDRESS_DELETE_REQUEST_SUCCESS";
export const ADDRESS_DELETE_REQUEST_FAIL = "ADDRESS_DELETE_REQUEST_FAIL";
export const ADDRESS_FIND_REQUEST = "ADDRESS_FIND_REQUEST";
export const ADDRESS_FIND_REQUEST_SUCCESS = "ADDRESS_FIND_REQUEST_SUCCESS";
export const ADDRESS_FIND_REQUEST_FAIL = "ADDRESS_FIND_REQUEST_FAIL";
export const SELECT_ADDRESS = "SELECT_ADDRESS";
export const SELECT_ADDRESSES = "SELECT_ADDRESSES";
export const CONTACTS_REQUEST = "CONTACTS_REQUEST";
export const CONTACTS_REQUEST_SUCCESS = "CONTACTS_REQUEST_SUCCESS";
export const CONTACTS_REQUEST_FAIL = "CONTACTS_REQUEST_FAIL";
export const CONTACT_CREATE_REQUEST = "CONTACT_CREATE_REQUEST";
export const CONTACT_CREATE_REQUEST_SUCCESS = "CONTACT_CREATE_REQUEST_SUCCESS";
export const CONTACT_CREATE_REQUEST_FAIL = "CONTACT_CREATE_REQUEST_FAIL";
export const CONTACT_UPDATE_REQUEST = "CONTACT_UPDATE_REQUEST";
export const CONTACT_UPDATE_REQUEST_SUCCESS = "CONTACT_UPDATE_REQUEST_SUCCESS";
export const CONTACT_UPDATE_REQUEST_FAIL = "CONTACT_UPDATE_REQUEST_FAIL";

export const CONTACT_DELETE_REQUEST = "CONTACT_DELETE_REQUEST";
export const CONTACT_DELETE_REQUEST_SUCCESS = "CONTACT_DELETE_REQUEST_SUCCESS";
export const CONTACT_DELETE_REQUEST_FAIL = "CONTACT_DELETE_REQUEST_FAIL";

export const CONTACT_FIND_REQUEST = "CONTACT_FIND_REQUEST";
export const CONTACT_FIND_REQUEST_SUCCESS = "CONTACT_FIND_REQUEST_SUCCESS";
export const CONTACT_FIND_REQUEST_FAIL = "CONTACT_FIND_REQUEST_FAIL";

export const SELECT_CONTACT = "SELECT_CONTACT";

export const RESET_SERVICE = "RESET_SERVICE";

export const SERVICES_REQUEST = "SERVICES_REQUEST";
export const SERVICES_REQUEST_SUCCESS = "SERVICES_REQUEST_SUCCESS";
export const SERVICES_REQUEST_FAIL = "SERVICES_REQUEST_FAIL";

export const SERVICE_CREATE_REQUEST = "SERVICE_CREATE_REQUEST";
export const SERVICE_CREATE_REQUEST_SUCCESS = "SERVICE_CREATE_REQUEST_SUCCESS";
export const SERVICE_CREATE_REQUEST_FAIL = "SERVICE_CREATE_REQUEST_FAIL";

export const SERVICE_UPDATE_REQUEST = "SERVICE_UPDATE_REQUEST";
export const SERVICE_UPDATE_REQUEST_SUCCESS = "SERVICE_UPDATE_REQUEST_SUCCESS";
export const SERVICE_UPDATE_REQUEST_FAIL = "SERVICE_UPDATE_REQUEST_FAIL";

export const SERVICE_DELETE_REQUEST = "SERVICE_DELETE_REQUEST";
export const SERVICE_DELETE_REQUEST_SUCCESS = "SERVICE_DELETE_REQUEST_SUCCESS";
export const SERVICE_DELETE_REQUEST_FAIL = "SERVICE_DELETE_REQUEST_FAIL";

export const SERVICE_FIND_REQUEST = "SERVICE_FIND_REQUEST";
export const SERVICE_FIND_REQUEST_SUCCESS = "SERVICE_FIND_REQUEST_SUCCESS";
export const SERVICE_FIND_REQUEST_FAIL = "SERVICE_FIND_REQUEST_FAIL";

export const SELECT_SERVICE = "SELECT_SERVICE";

export const SERVICEORDERS_REQUEST = "SERVICEORDERS_REQUEST";
export const SERVICEORDERS_REQUEST_SUCCESS = "SERVICEORDERS_REQUEST_SUCCESS";
export const SERVICEORDERS_REQUEST_FAIL = "SERVICEORDERS_REQUEST_FAIL";
export const SERVICEORDERS_REQUEST_STOP = "SERVICEORDERS_REQUEST_STOP";

export const SERVICEORDER_CREATE_REQUEST = "SERVICEORDER_CREATE_REQUEST";
export const SERVICEORDER_CREATE_REQUEST_SUCCESS =
  "SERVICEORDER_CREATE_REQUEST_SUCCESS";
export const SERVICEORDER_CREATE_REQUEST_FAIL =
  "SERVICEORDER_CREATE_REQUEST_FAIL";
export const SERVICEORDER_UPDATE_REQUEST = "SERVICEORDER_UPDATE_REQUEST";
export const SERVICEORDER_CANCEL = "SERVICEORDER_CANCEL";
export const SERVICEORDER_BILL = "SERVICEORDER_BILL";

export const SERVICEORDER_UPDATE_REQUEST_SUCCESS =
  "SERVICEORDER_UPDATE_REQUEST_SUCCESS";
export const SERVICEORDER_UPDATE_REQUEST_FAIL =
  "SERVICEORDER_UPDATE_REQUEST_FAIL";
export const SERVICEORDER_DELETE_REQUEST = "SERVICEORDER_DELETE_REQUEST";

export const SERVICEORDER_DELETE_REQUEST_SUCCESS =
  "SERVICEORDER_DELETE_REQUEST_SUCCESS";
export const SERVICEORDER_DELETE_REQUEST_FAIL =
  "SERVICEORDER_DELETE_REQUEST_FAIL";
export const SERVICEORDER_FIND_REQUEST = "SERVICEORDER_FIND_REQUEST";

export const SERVICEORDER_FIND_REQUEST_SUCCESS =
  "SERVICEORDER_FIND_REQUEST_SUCCESS";
export const SERVICEORDER_FIND_REQUEST_FAIL = "SERVICEORDER_FIND_REQUEST_FAIL";
export const SELECT_SERVICEORDER = "SELECT_SERVICEORDER";

export const SERVICEORDERS_CONTRACTOR_REQUEST =
  "SERVICEORDERS_CONTRACTOR_REQUEST";
export const SERVICEORDERS_CONTRACTOR_REQUEST_FAIL =
  "SERVICEORDERS_CONTRACTOR_REQUEST_FAIL";
export const SERVICEORDERS_CONTRACTOR_REQUEST_SUCCESS =
  "SERVICEORDERS_CONTRACTOR_REQUEST_SUCCESS";

export const PROVIDER_CREATE_REQUEST = "PROVIDER_CREATE_REQUEST";
export const PROVIDER_CREATE_REQUEST_SUCCESS =
  "PROVIDER_CREATE_REQUEST_SUCCESS";
export const PROVIDER_CREATE_REQUEST_FAIL = "PROVIDER_CREATE_REQUEST_FAIL";

export const PROVIDER_REMOVE_REQUEST = "PROVIDER_REMOVE_REQUEST";
export const SELECT_PROVIDER = "SELECT_PROVIDER";
export const SELECT_PROVIDER_ID = "SELECT_PROVIDER_ID";
export const ALL_PROVIDERS_INVITES = "ALL_PROVIDERS_INVITES";
export const ALL_PROVIDERS_INVITES_SUCCESS = "ALL_PROVIDERS_INVITES_SUCCESS";
export const ALL_PROVIDERS_INVITES_FAIL = "ALL_PROVIDERS_INVITES_FAIL";
export const RESET_INVITES = "RESET_INVITES";
export const PROVIDER_REMOVE_REQUEST_SUCCESS =
  "PROVIDER_REMOVE_REQUEST_SUCCESS";
export const PROVIDER_REMOVE_REQUEST_FAIL = "PROVIDER_REMOVE_REQUEST_FAIL";

export const PROVIDERS_REQUEST = "PROVIDERS_REQUEST";
export const PROVIDERS_HIRER_REQUEST_SUCCESS =
  "PROVIDERS_HIRER_REQUEST_SUCCESS";
export const PROVIDERS_HIRER_REQUEST_FAIL = "PROVIDERS_HIRER_REQUEST_FAIL";

export const PROVIDERS_REQUEST_SUCCESS = "PROVIDERS_REQUEST_SUCCESS";
export const PROVIDERS_REQUEST_FAIL = "PROVIDERS_REQUEST_FAIL";

export const AGENTS_LIST_REQUEST = "AGENTS_LIST_REQUEST";
export const AGENTS_LIST_REQUEST_SUCCESS = "AGENTS_LIST_REQUEST_SUCCESS";
export const AGENTS_LIST_REQUEST_FAIL = "AGENTS_LIST_REQUEST_FAIL";

export const SEARCH_CONTRACTOR_REQUEST = "SEARCH_CONTRACTOR_REQUEST";
export const SEARCH_CONTRACTOR_REQUEST_SUCCESS =
  "SEARCH_CONTRACTOR_REQUEST_SUCCESS";
export const SEARCH_CONTRACTOR_FAIL = "SEARCH_CONTRACTOR_FAIL";

export const SEARCH_CUSTOMER_REQUEST = "SEARCH_CUSTOMER_REQUEST";
export const SEARCH_CUSTOMER_REQUEST_SUCCESS =
  "SEARCH_CUSTOMER_REQUEST_SUCCESS";
export const SEARCH_CUSTOMER_REQUEST_FAIL = "SEARCH_CUSTOMER_REQUEST_FAIL";

export const SEARCH_ADDRESS_REQUEST = "SEARCH_ADDRESS_REQUEST";
export const SEARCH_ADDRESS_REQUEST_SUCCESS = "SEARCH_ADDRESS_REQUEST_SUCCESS";
export const SEARCH_ADDRESS_REQUEST_FAIL = "SEARCH_ADDRESS_REQUEST_FAIL";

export const SEARCH_CONTACT_REQUEST = "SEARCH_CONTACT_REQUEST";
export const SEARCH_CONTACT_REQUEST_SUCCESS = "SEARCH_CONTACT_REQUEST_SUCCESS";
export const SEARCH_CONTACT_REQUEST_FAIL = "SEARCH_CONTACT_REQUEST_FAIL";

export const SEARCH_SERVICE_REQUEST = "SEARCH_SERVICE_REQUEST";
export const SEARCH_SERVICE_REQUEST_SUCCESS = "SEARCH_SERVICE_REQUEST_SUCCESS";
export const SEARCH_SERVICE_REQUEST_FAIL = "SEARCH_SERVICE_REQUEST_FAIL";

export const SEARCH_BUDGET_REQUEST = "SEARCH_BUDGET_REQUEST";
export const SEARCH_BUDGET_REQUEST_SUCCESS = "SEARCH_BUDGET_REQUEST_SUCCESS";
export const SEARCH_BUDGET_REQUEST_FAIL = "SEARCH_BUDGET_REQUEST_FAIL";

export const ACCOUNT_LOGIN_REQUEST = "ACCOUNT_LOGIN_REQUEST";
export const ACCOUNT_LOGIN_REQUEST_SUCCESS = "ACCOUNT_LOGIN_REQUEST_SUCCESS";
export const ACCOUNT_LOGIN_REQUEST_FAIL = "ACCOUNT_LOGIN_REQUEST_FAIL";

export const ACCOUNT_EMAIL_USER = "ACCOUNT_EMAIL_USER";

export const ACCOUNT_RESET_PASSWORD_REQUEST = "ACCOUNT_RESET_PASSWORD_REQUEST";
export const ACCOUNT_RESET_PASSWORD_REQUEST_SUCCESS =
  "ACCOUNT_RESET_PASSWORD_REQUEST_SUCCESS";
export const ACCOUNT_RESET_PASSWORD_REQUEST_FAIL =
  "ACCOUNT_RESET_PASSWORD_REQUEST_FAIL";

export const RESET_ADDRESS_SEARCH = "RESET_ADDRESS_SEARCH";
export const RESET_CONTACTS = "RESET_CONTACTS";
export const RESET_SERVICE_SEARCH = "RESET_SERVICE_SEARCH";
export const RESET_CUSTOMER_SEARCH = "RESET_CUSTOMER_SEARCH";
export const RESET_PROVIDERS = "RESET_PROVIDERS";
export const RESET_CUSTOMERS = "RESET_CUSTOMERS";

export const DASHBOARDS_REQUEST = "DASHBOARDS_REQUEST";
export const DASHBOARDS_REQUEST_SUCCESS = "DASHBOARDS_REQUEST_SUCCESS";
export const DASHBOARDS_REQUEST_FAIL = "DASHBOARDS_REQUEST_FAIL";

export const DASHBOARD_CREATE_REQUEST = "DASHBOARD_CREATE_REQUEST";
export const DASHBOARD_CREATE_REQUEST_SUCCESS =
  "DASHBOARD_CREATE_REQUEST_SUCCESS";
export const DASHBOARD_CREATE_REQUEST_FAIL = "DASHBOARD_CREATE_REQUEST_FAIL";
export const DASHBOARD_UPDATE_REQUEST = "DASHBOARD_UPDATE_REQUEST";

export const DASHBOARD_UPDATE_REQUEST_SUCCESS =
  "DASHBOARD_UPDATE_REQUEST_SUCCESS";
export const DASHBOARD_UPDATE_REQUEST_FAIL = "DASHBOARD_UPDATE_REQUEST_FAIL";
export const DASHBOARD_DELETE_REQUEST = "DASHBOARD_DELETE_REQUEST";

export const DASHBOARD_DELETE_REQUEST_SUCCESS =
  "DASHBOARD_DELETE_REQUEST_SUCCESS";
export const DASHBOARD_DELETE_REQUEST_FAIL = "DASHBOARD_DELETE_REQUEST_FAIL";
export const DASHBOARD_FIND_REQUEST = "DASHBOARD_FIND_REQUEST";

export const DASHBOARD_FIND_REQUEST_SUCCESS = "DASHBOARD_FIND_REQUEST_SUCCESS";
export const DASHBOARD_FIND_REQUEST_FAIL = "DASHBOARD_FIND_REQUEST_FAIL";
export const SELECT_DASHBOARD = "SELECT_DASHBOARD";

export const SERVICEORDER_ATTACHMENT_REQUEST =
  "SERVICEORDER_ATTACHMENT_REQUEST";

export const SERVICEORDER_ATTACHMENT_DELETE_REQUEST =
  "SERVICEORDER_ATTACHMENT_DELETE_REQUEST";

export const INVOICE_FILE_REQUEST = "INVOICE_FILE_REQUEST";

export const GET_ATTACHMENTS_REQUEST = "GET_ATTACHMENTS_REQUEST";
export const GET_FILES_REQUEST = "GET_FILES_REQUEST";
export const GET_FILES_REQUEST_FAIL = "GET_FILES_REQUEST_FAIL";
export const GET_FILES_REQUEST_SUCCESS = "GET_FILES_REQUEST_SUCCESS";

export const GET_ATTACHMENTS_REQUEST_FAIL = "GET_ATTACHMENTS_REQUEST_FAIL";
export const GET_ATTACHMENTS_REQUEST_SUCCESS =
  "GET_ATTACHMENTS_REQUEST_SUCCESS";

export const BUDGETS_PROPOSALS_REQUEST = "BUDGETS_PROPOSALS_REQUEST";
export const BUDGETS_PROPOSALS_REQUEST_FAIL = "BUDGETS_PROPOSALS_REQUEST_FAIL";
export const BUDGETS_PROPOSALS_REQUEST_SUCCESS =
  "BUDGETS_PROPOSALS_REQUEST_SUCCESS";

export const BUDGET_PROPOSAL_CREATE_REQUEST = "BUDGET_PROPOSAL_CREATE_REQUEST";
export const BUDGET_PROPOSAL_CREATE_REQUEST_SUCCESS =
  "BUDGET_PROPOSAL_CREATE_REQUEST_SUCCESS";
export const BUDGET_PROPOSAL_CREATE_REQUEST_FAIL =
  "BUDGET_PROPOSAL_CREATE_REQUEST_FAIL";

export const SELECT_PROPOSAL_BUDGET = "SELECT_PROPOSAL_BUDGET";

export const BUDGET_PROPOSAL_UPDATE_REQUEST = "BUDGET_PROPOSAL_UPDATE_REQUEST";

export const BUDGET_TO_TRANPO = "BUDGET_TO_TRANPO";
export const GET_PDF = "GET_PDF";

export const INVOICES_REQUEST = "INVOICES_REQUEST";
export const INVOICES_REQUEST_SUCCESS = "INVOICES_REQUEST_SUCCESS";
export const INVOICES_REQUEST_FAIL = "INVOICES_REQUEST_FAIL";
export const SELECT_INVOICE = "SELECT_INVOICE";

export const INVOICE_CREATE_REQUEST_SUCCESS = "INVOICE_CREATE_REQUEST_SUCCESS";
export const INVOICE_CREATE_REQUEST_FAIL = "INVOICE_CREATE_REQUEST_FAIL";
export const INVOICE_CREATE_REQUEST = "INVOICE_CREATE_REQUEST";

export const INVOICE_CREATE_BULK_REQUEST_SUCCESS =
  "INVOICE_CREATE_BULK_REQUEST_SUCCESS";
export const INVOICE_CREATE_BULK_REQUEST_FAIL =
  "INVOICE_CREATE_BULK_REQUEST_FAIL";
export const INVOICE_CREATE_BULK_REQUEST = "INVOICE_CREATE_BULK_REQUEST";

export const INVOICE_GET_OS_REQUEST_SUCCESS = "INVOICE_GET_OS_REQUEST_SUCCESS";
export const INVOICE_GET_OS_REQUEST_FAIL = "INVOICE_GET_OS_REQUEST_FAIL";
export const INVOICE_GET_OS_REQUEST = "INVOICE_GET_OS_REQUEST";
export const RESET_INVITE_OS = "RESET_INVITE_OS";

export const INVOICE_UPDATE_REQUEST_SUCCESS = "INVOICE_UPDATE_REQUEST_SUCCESS";
export const INVOICE_UPDATE_REQUEST_FAIL = "INVOICE_UPDATE_REQUEST_FAIL";
export const INVOICE_UPDATE_REQUEST = "INVOICE_UPDATE_REQUEST";
export const INVOICE_FIND_REQUEST_SUCCESS = "INVOICE_FIND_REQUEST_SUCCESS";
export const INVOICE_FIND_REQUEST_FAIL = "INVOICE_FIND_REQUEST_FAIL";
export const INVOICE_FIND_REQUEST = "INVOICE_FIND_REQUEST";
export const INVOICED_REQUEST = "INVOICED_REQUEST";
export const INVOICE_DELETE_REQUEST = "INVOICE_DELETE_REQUEST";

export const RECEIPT_CREATE_REQUEST = "RECEIPT_CREATE_REQUEST";
export const RECEIPT_CREATE_REQUEST_SUCCESS = "RECEIPT_CREATE_REQUEST_SUCCESS";
export const RECEIPT_CREATE_REQUEST_FAIL = "RECEIPT_CREATE_REQUEST_FAIL";

export const RECEIPT_LIST_REQUEST = "RECEIPT_LIST_REQUEST";
export const RECEIPT_LIST_REQUEST_SUCCESS = "RECEIPT_LIST_REQUEST_SUCCESS";
export const RECEIPT_LIST_REQUEST_FAIL = "RECEIPT_LIST_REQUEST_FAIL";

export const RECEIPT_PROVIDER_LIST_REQUEST = "RECEIPT_PROVIDER_LIST_REQUEST";
export const RECEIPT_PROVIDER_LIST_REQUEST_SUCCESS =
  "RECEIPT_PROVIDER_LIST_REQUEST_SUCCESS";
export const RECEIPT_PROVIDER_LIST_REQUEST_FAIL =
  "RECEIPT_PROVIDER_LIST_REQUEST_FAIL";

export const RECEIPT_DELETE_REQUEST = "RECEIPT_DELETE_REQUEST";
export const PROVIDER_DELETE_REQUEST = "PROVIDER_DELETE_REQUEST";

export const PROVIDERINSTRUCTIONS_CREATE_REQUEST =
  "PROVIDERINSTRUCTIONS_CREATE_REQUEST";
export const PROVIDERINSTRUCTIONS_DELETE_REQUEST =
  "PROVIDERINSTRUCTIONS_DELETE_REQUEST";

export const CONTRACTORINSTRUCTIONS_CREATE_REQUEST =
  "CONTRACTORINSTRUCTIONS_CREATE_REQUEST";
export const CONTRACTORINSTRUCTIONS_DELETE_REQUEST =
  "CONTRACTORINSTRUCTIONS_DELETE_REQUEST";

export const TICKET_CREATE_REQUEST = "TICKET_CREATE_REQUEST";
export const TICKET_CREATE_REQUEST_SUCCESS = "TICKET_CREATE_REQUEST_SUCCESS";
export const TICKET_CREATE_REQUEST_FAIL = "TICKET_CREATE_REQUEST_FAIL";

export const TICKET_LIST_REQUEST = "TICKET_LIST_REQUEST";
export const TICKET_LIST_REQUEST_SUCCESS = "TICKET_LIST_REQUEST_SUCCESS";
export const TICKET_LIST_REQUEST_FAIL = "TICKET_LIST_REQUEST_FAIL";

export const TECSUBMIT_IMAGES = "TECSUBMIT_IMAGES";
export const TECSUBMIT_IMAGES_SUCCESS = "TECSUBMIT_IMAGES_SUCCESS";
export const TECSUBMIT_IMAGES_FAIL = "TECSUBMIT_IMAGES_FAIL";

export const ATTACHMENTS_LIST_REQUEST = "ATTACHMENTS_LIST_REQUEST";
export const ATTACHMENTS_LIST_REQUEST_SUCCESS =
  "ATTACHMENTS_LIST_REQUEST_SUCCESS";
export const ATTACHMENTS_LIST_REQUEST_FAIL = "ATTACHMENTS_LIST_REQUEST_FAIL";

export const TICKET_LIST_BY_ID_REQUEST = "TICKET_LIST_BY_ID_REQUEST";
export const TICKET_LIST_BY_ID_REQUEST_SUCCESS =
  "TICKET_LIST_BY_ID_REQUEST_SUCCESS";
export const TTICKET_LIST_BY_ID_REQUEST_FAIL =
  "TTICKET_LIST_BY_ID_REQUEST_FAIL";

export const TICKET_DELETE_REQUEST = "TICKET_DELETE_REQUEST";

export const QUIZ_CREATE_REQUEST = "QUIZ_CREATE_REQUEST";
export const QUIZ_CREATE_REQUEST_SUCCESS = "QUIZ_CREATE_REQUEST_SUCCESS";
export const QUIZ_CREATE_REQUEST_FAIL = "QUIZ_CREATE_REQUEST_FAIL";
export const QUIZ_UPDATE_REQUEST = "QUIZ_UPDATE_REQUEST";
export const QUIZ_UPDATE_REQUEST_SUCCESS = "QUIZ_UPDATE_REQUEST_SUCCESS";
export const QUIZ_UPDATE_REQUEST_FAIL = "QUIZ_UPDATE_REQUEST_FAIL";
export const QUIZ_FIND_REQUEST = "QUIZ_FIND_REQUEST";
export const QUIZ_FIND_REQUEST_SUCCESS = "QUIZ_FIND_REQUEST_SUCCESS";
export const QUIZ_FIND_REQUEST_FAIL = "QUIZ_FIND_REQUEST_FAIL";
export const QUIZ_DELETE_REQUEST = "QUIZ_DELETE_REQUEST";
export const QUIZ_DELETE_REQUEST_SUCCESS = "QUIZ_DELETE_REQUEST_SUCCESS";
export const QUIZ_DELETE_REQUEST_FAIL = "QUIZ_DELETE_REQUEST_FAIL";
export const SELECT_QUIZ = "SELECT_QUIZ";

export const QUESTIONNAIRES_REQUEST = "QUESTIONNAIRES_REQUEST";
export const QUESTIONNAIRES_REQUEST_SUCCESS = "QUESTIONNAIRES_REQUEST_SUCCESS";
export const QUESTIONNAIRES_REQUEST_FAIL = "QUESTIONNAIRES_REQUEST_FAIL";
export const SERVICEORDER_PENDING_REQUEST_SUCCESS =
  "SERVICEORDER_PENDING_REQUEST_SUCCESS";
export const SERVICEORDER_PENDING_REQUEST_FAIL =
  "SERVICEORDER_PENDING_REQUEST_FAIL";
export const SERVICEORDER_PENDING_REQUEST = "SERVICEORDER_PENDING_REQUEST";

export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";
export const CHANGE_PASSWORD_REQUEST_SUCCESS =
  "CHANGE_PASSWORD_REQUEST_SUCCESS";
export const CHANGE_PASSWORD_REQUEST_FAIL = "CHANGE_PASSWORD_REQUEST_FAIL";

export const SAVE_EMAIL_LOGIN = "SAVE_EMAIL_LOGIN";
export const SAVE_EMAIL_LOGIN_SUCCESS = "SAVE_EMAIL_LOGIN_SUCCESS";
export const SAVE_EMAIL_LOGIN_FAIL = "SAVE_EMAIL_LOGIN_FAIL";

export const REPORT_REQUEST_CREATE = "REPORT_REQUEST_CREATE";
export const REPORT_REQUEST_CREATE_FAIL = "REPORT_REQUEST_CREATE_FAIL";
export const REPORT_REQUEST = "REPORT_REQUEST";
export const REPORT_REQUEST_FAIL = "REPORT_REQUEST_FAIL";
export const REPORT_REQUEST_SUCCESS = "REPORT_REQUEST_SUCCESS";

export const NOTIFICATIONS_REQUEST = "NOTIFICATIONS_REQUEST";
export const RESET_NOTIFICATIONS = "RESET_NOTIFICATIONS";

export const INVITE_CREATE_REQUEST = "INVITE_CREATE_REQUEST";
export const INVITE_CREATE_REQUEST_FAIL = "INVITE_CREATE_REQUEST_FAIL";
export const INVITE_CREATE_REQUEST_SUCCESS = "INVITE_CREATE_REQUEST_SUCCESS";
export const INVITE_DELETE = "INVITE_DELETE";

export const SEARCH_TONTON_ADDRESS = "SEARCH_TONTON_ADDRESS";
export const SEARCH_TONTON_ADDRESS_FAIL = "SEARCH_TONTON_ADDRESS_FAIL";
export const SEARCH_TONTON_ADDRESS_SUCCESS = "SEARCH_TONTON_ADDRESS_SUCCESS";

export const RESET_SERVICE_ORDER = "RESET_SERVICE_ORDER";

export const CHECK_EMAIL_REQUEST = "CHECK_EMAIL_REQUEST";
export const CHECK_EMAIL_REQUEST_SUCCESS = "CHECK_EMAIL_REQUEST_SUCCESS";
export const CHECK_EMAIL_REQUEST_FAIL = "CHECK_EMAIL_REQUEST_FAIL";


// WEBPACK FOOTER //
// ./src/redux/action.types.js